var map = {
	"./1.svg": "710b",
	"./2.svg": "de92",
	"./3.svg": "75bd",
	"./4.svg": "4494",
	"./5.svg": "fe3c",
	"./5b.svg": "37b5",
	"./6.svg": "7c06",
	"./7.svg": "94db",
	"./8.svg": "ac3e",
	"./9.svg": "d888"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9dfb";